export const ROUTES = {
  home: "/",
  about: "/about",
  faq: "/faq",
  contact_us: "/contact-us",
  privacy_policy: "/privacy-policy",
  terms_of_service: "/terms",
};
